<template>
	<div :style="{width:'100%', height:innerHeight}">
        <iframe
        scrolling="no"
        style="border:0; pointer-events: none;"
        :style="{width:'100%',height:innerHeight}"
        :src="displayUrl">
        </iframe>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'LightStream',
	data() {
		return {
		};
	},
	methods: {
		...mapActions({
			setNavbarVisible: 'setNavbarVisible',
			setDrawerVisible: 'setDrawerVisible',
		}),
	},
	computed: {
		displayUrl() {
			const urlPath = window.location.href.replace(window.location.origin, '');
			return `${process.env.VUE_APP_URL}/displays${urlPath.substr(12, urlPath.length)}`;
		},
		innerHeight() {
			return `${window.innerHeight}px`;
		},
	},
	beforeDestroy() {
		this.$nextTick(() => {
			$(document).find('main').addClass('main');
			$('body').css('background-color', '');
			$('html.md-theme-default').css('background-color', '');
			$('html').css('overflow', 'visible');
			$('.main, main').css('filter', '');
			this.setNavbarVisible(true);
			this.setDrawerVisible(true);
		});
	},
	created() {
		this.$nextTick(() => {
			$('body').css('background-color', 'transparent');
			$('html.md-theme-default').css('background-color', 'transparent');
			$(document).find('main').removeClass('main');
			$('html').css('overflow', 'hidden');
			this.setNavbarVisible(false);
			this.setDrawerVisible(false);
		});
	},
};
</script>
